<template>
  <v-layout>
    <v-layout column>
      <v-img width="200" :src="imageInfo.thumbnailUrl"></v-img>
      <v-col class="caption px-0 pt-1 pb-0">
        {{ resource.text }} |
        <v-icon x-small>label</v-icon>
        <template v-for="tag in tags">
          {{ tag.text }}
        </template>
      </v-col>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    resource: { default: () => ({}) },
    imageInfo: { default: () => ({}) }
  },
  data() {
    return {
    };
  },
  computed: {
    tags() {
      return this.resource.tags.userDefined;
    }
  },
  methods: {}
};
</script>

<style>
</style>
